/* cf-sticky-next.js — 7 Oct 2026 (Pete: "put together all the fixes").
   Why: the leak inspection found people choose how many sections, then never reach the length boxes.
   On step 1 (Add Sections) the "Next →" button sits ~1,300px down, under colour, height and the other
   shared choices, so it is off screen. When the real button is enabled but out of view, this shows a
   copy of it pinned bottom-left (the red "Got a question?" button keeps bottom-right). Pressing it
   scrolls to the real button (past the shared choices, so none is skipped). Same words as the real button, read from it live. No price, no state, no
   calculator code touched. Remove the meta-tags line to roll back. */
(function () {
  'use strict';
  if (window.__cfStickyNext) return;
  window.__cfStickyNext = true;
  var PATHS = ['/pages/blade-fence-calculator', '/pages/flat-top-fence-calculator', '/pages/glass-fencing', '/pages/perfmesh-fence'];
  var path = (location.pathname || '/').replace(/\/+$/, '');
  if (PATHS.indexOf(path) === -1) return;

  var pill = null;
  function makePill(real) {
    pill = document.createElement('button');
    pill.type = 'button';
    pill.id = 'cf-sticky-next';
    pill.setAttribute('aria-label', 'Go to the next step');
    var cs = window.getComputedStyle(real);
    pill.style.cssText = [
      'position:fixed', 'left:16px', 'bottom:calc(16px + env(safe-area-inset-bottom, 0px))', 'z-index:2147482000',
      'padding:12px 22px', 'border:0', 'border-radius:999px', 'cursor:pointer',
      'font:600 16px/1.2 ' + cs.fontFamily, 'color:' + cs.color, 'background:' + cs.backgroundColor,
      'box-shadow:0 6px 18px rgba(0,0,0,.25)', 'display:none'
    ].join(';');
    pill.addEventListener('click', function () {
      // Scroll to the real button rather than pressing it: the customer still passes the colour,
      // height and other shared choices on the way, so nothing is skipped on a default.
      try {
        var r = document.getElementById('sections-next-btn');
        // Instant, not smooth: smooth scrolling does nothing on these pages (tested 7 Oct).
        if (r) r.scrollIntoView({ block: 'end' });
      } catch (e) {}
      setTimeout(update, 150);
    });
    document.body.appendChild(pill);
  }

  function update() {
    try {
      var real = document.getElementById('sections-next-btn');
      if (!real) return;
      if (!pill) makePill(real);
      var shown = real.offsetParent !== null && !real.disabled;
      if (shown) {
        var r = real.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        shown = r.top > vh - 20; // only while the real button is still BELOW the screen
      }
      if (shown) pill.textContent = (real.innerText || real.textContent || 'Next →').trim();
      pill.style.display = shown ? 'block' : 'none';
    } catch (e) {}
  }

  var t = null;
  function soon() { clearTimeout(t); t = setTimeout(update, 120); }
  window.addEventListener('scroll', soon, { passive: true });
  window.addEventListener('resize', soon);
  document.addEventListener('change', soon, true);
  document.addEventListener('click', soon, true);
  setInterval(update, 1500);
  update();
  try { console.log('[cf-sticky-next] installed'); } catch (e) {}
})();
